import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';

interface LocationState {
  from?: Location;
  requiredRoles?: string[];
  userRole?: string | null;
}

export const UnauthorizedPage: React.FC = () => {
  const location = useLocation();
  const state = location.state as LocationState;

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full bg-white shadow-lg rounded-lg p-6">
        <div className="flex items-center justify-center w-12 h-12 mx-auto bg-red-100 rounded-full mb-4">
          <AlertTriangle className="w-6 h-6 text-red-600" />
        </div>
        
        <div className="text-center">
          <h1 className="text-2xl font-bold text-gray-900 mb-2">Access Denied</h1>
          <p className="text-gray-600 mb-4">
            You don't have permission to access this page.
          </p>
          
          {state?.requiredRoles && (
            <div className="bg-gray-50 rounded-md p-3 mb-4">
              <p className="text-sm text-gray-700">
                <strong>Required roles:</strong> {state.requiredRoles.join(', ')}
              </p>
              {state.userRole && (
                <p className="text-sm text-gray-700">
                  <strong>Your role:</strong> {state.userRole}
                </p>
              )}
            </div>
          )}
          
          <Link
            to="/signin"
            className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            Sign In
          </Link>
        </div>
      </div>
    </div>
  );
}; 